import { ITicker } from '@kattana-io/common';
import { action } from 'typesafe-actions';
import { IGridItem } from '../reducers/grid';

export interface IAddPayload {
    rows: number[];
    cols: number[];
    net: {
        [key: string]: IGridItem;
    };
}

export interface ISwitchPrimaryPayload {
    newPrimaryKey: string;
}

export interface IChangeTickerPayload {
    key: string;
    ticker: ITicker;
}

export interface IChangePrimaryTickerPayload {
    ticker: ITicker;
    exchange: string;
}

export interface ICHangeTickersExchangePayload {
    tickerKey: string;
    exchange: string;
}

const entity = 'grid';

const ADD = `${entity}/ADD`;
const SWITCH_PRIMARY = `${entity}/SWITCH_PRIMARY`;
const CHANGE_TICKER = `${entity}/CHANGE_TICKER`;
const CHANGE_PRIMARY_TICKER = `${entity}/CHANGE_PRIMARY_TICKER`;
const CHANGE_TICKERS_EXCHANGE = `${entity}/CHANGE_TICKERS_EXCHANGE`;

const actionAddGrid = (payload: IAddPayload) => action(ADD, payload);
const actionSwitchPrimary = (payload: ISwitchPrimaryPayload) => action(SWITCH_PRIMARY, payload);
const actionChangeTicker = (payload: IChangeTickerPayload) => action(CHANGE_TICKER, payload);
const actionChangePrimaryTicker = (payload: IChangePrimaryTickerPayload) => action(CHANGE_PRIMARY_TICKER, payload);
const actionChangeTickersExchange = (payload: ICHangeTickersExchangePayload) => action(CHANGE_TICKERS_EXCHANGE, payload);

export {
  ADD,
  SWITCH_PRIMARY,
  CHANGE_TICKER,
  CHANGE_PRIMARY_TICKER,
  CHANGE_TICKERS_EXCHANGE,
  actionAddGrid,
  actionSwitchPrimary,
  actionChangeTicker,
  actionChangePrimaryTicker,
  actionChangeTickersExchange
};
